// src/components/nodes/DecisionNode.js
import { NodeBase } from './NodeBase';

export class DecisionNode extends NodeBase {
  constructor() {
    super('decision', { label: '判断条件？' });
  }

  renderContent(data, selected) {
    return (
      <div className="decision-content">
        <div className="decision-text">
          {data.label}
        </div>
      </div>
    );
  }

  getConfig() {
    return {
      type: this.type,
      label: '决策节点',
      icon: '🔷',
      defaultData: this.defaultData
    };
  }
}